import '@mdi/font/css/materialdesignicons.css'
import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import gem from '@/components/icons/gem.vue'
import emptyGem from '@/components/icons/empty-gem.vue'
// import 'vuetify/src/stylus/app.styl'
// import '../theme/default.styl'
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      gem: {
        component: gem
      },
      emptyGem: {
        component: emptyGem
      }
    }
  },
});

